import { buoyTemperatureColorScale } from '../map/buoyTemperatureLegendUtils';
import DOMPurify from 'dompurify';

export default function BuoyMapLayerIcon({ cluster }) {
  function windArrow(deg) {
    if (typeof deg !== 'number') return '';
    return `<span style="display:inline-block;transform:rotate(${deg}deg);font-size:40px;">&#8593;</span>`;
  }

  function extractBuoyData(point) {
    let temp = null;
    let wind = null;
    let wave = null;
    let dir = null;

    if (Array.isArray(point.data)) {
      for (const datapoint of point.data) {
        if (datapoint.air_temperature != null && temp == null) temp = datapoint.air_temperature;
        if (datapoint.wind_speed != null && wind == null) wind = datapoint.wind_speed;
        if (datapoint.wave_height != null && wave == null) wave = datapoint.wave_height;
        if (datapoint.wind_direction != null && dir == null) dir = datapoint.wind_direction;
      }
    }

    return { temp, wind, wave, dir };
  }

  let tempSum = 0;
  let tempCount = 0;
  let windSum = 0;
  let windCount = 0;
  let waveSum = 0;
  let waveCount = 0;
  let dirSum = 0;
  let dirCount = 0;

  for (const point of cluster) {
    const { temp, wind, wave, dir } = extractBuoyData(point);
    const tempNum = typeof temp === 'string' ? Number(temp) : temp;
    const windNum = typeof wind === 'string' ? Number(wind) : wind;
    const waveNum = typeof wave === 'string' ? Number(wave) : wave;
    const dirNum = typeof dir === 'string' ? Number(dir) : dir;

    if (typeof tempNum === 'number' && Number.isFinite(tempNum)) {
      tempSum += tempNum;
      tempCount++;
    }
    if (typeof windNum === 'number' && Number.isFinite(windNum)) {
      windSum += windNum;
      windCount++;
    }
    if (typeof waveNum === 'number' && Number.isFinite(waveNum)) {
      waveSum += waveNum;
      waveCount++;
    }
    if (typeof dirNum === 'number' && Number.isFinite(dirNum)) {
      dirSum += dirNum;
      dirCount++;
    }
  }

  const avgTemp = tempCount ? tempSum / tempCount : null;
  const avgWind = windCount ? windSum / windCount : null;
  const avgWave = waveCount ? waveSum / waveCount : null;
  const avgDir = dirCount ? dirSum / dirCount : null;

  if (avgTemp == null || Number.isNaN(avgTemp)) return null;

  const color = buoyTemperatureColorScale(avgTemp);
  const tempText = `${avgTemp.toFixed(1)}\u00B0F`;
  const windText = avgWind != null && Number.isFinite(avgWind) ? avgWind.toFixed(1) + ' MPH' : '*';
  const waveText = avgWave != null && Number.isFinite(avgWave) ? avgWave.toFixed(1) + ' FT' : '*';
  const arrow = DOMPurify.sanitize(windArrow(avgDir));

  return (
    <div
      style={{
        borderRadius: '6px',
        padding: '6px 10px',
        textAlign: 'center',
        background: 'rgba(0,0,0,0)',
        color,
        fontWeight: 'bold',
        fontSize: 20,
        textShadow: '-2px 0 black, 0 2px black, 2px 0 black, 0 -2px black',
        width: 180,
        minHeight: 60,
        display: 'inline-block',
      }}
    >
      <div>{tempText}</div>
      <div style={{ color: 'white', fontSize: 16 }}>Wind SP: {windText}</div>
      <div style={{ color: 'white', fontSize: 16 }}>Wave Height: {waveText}</div>
      <div dangerouslySetInnerHTML={{ __html: arrow }} />
      {cluster.length > 1 && (
        <div style={{ color: '#ff0', fontSize: 14 }}>{cluster.length} buoys</div>
      )}
    </div>
  );
}
